module.exports = __webpack_public_path__ + "img/cc0e4b2.png";